function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isTesting } from '@square/dashboard-utilities/utils/ember';
import { getOneTrustActiveGroups, getOneTrustConsentModel } from '@square/dashboard-utilities/utils/window';
import { registerDestructor } from '@ember/destroyable';
export const onetrustWindow = window;
export let OneTrustConsent = /*#__PURE__*/function (OneTrustConsent) {
  OneTrustConsent["STRICTLY_NECESSARY"] = "C0001";
  OneTrustConsent["PERFORMANCE"] = "C0002";
  OneTrustConsent["FUNCTIONAL"] = "C0003";
  OneTrustConsent["TARGETING"] = "C0004";
  return OneTrustConsent;
}({});
export class EnvoyConsentHeader {
  constructor() {
    _defineProperty(this, 'X-Block-Cookies', void 0);
    _defineProperty(this, 'X-Allow-Cookies', void 0);
  }
}
export const X_ALLOW_COOKIES = 'X-Allow-Cookies';
export const X_BLOCK_COOKIES = 'X-Block-Cookies';
export const X_BLOCK_COOKIES_DEFAULT_VALUE = 'true';
export const POST_NEW_ONE_TRUST_INSTANCE = 'dashboardSqOneTrustInstanceChangedEvent';
export const ONE_TRUST_ALERT_COOKIE = 'OptanonAlertBoxClosed';
export function hasConsentBeenSet() {
  // `getOneTrustActiveGroups()` will only be undefined if the OneTrust script has not run.
  const noConsentFound = !getOneTrustActiveGroups();
  // If the merchant has anything other than strictly necessary cookies, they have either selected consent or been auto-consented (US/CA).
  const hasAutoConsented = /C000[^1]/.test(getOneTrustActiveGroups());
  // If the merchant is in an opt-out region, they will be auto-consented
  const isInOptOutRegion = getOneTrustConsentModel() === 'opt-out';
  // If neither of those are true, and there is an `OptanonAlertBoxClosed` cookie, the merchant has consented through the modal.
  const hasManuallyConsented = document.cookie.includes(ONE_TRUST_ALERT_COOKIE);
  return Boolean(noConsentFound || hasAutoConsented || isInOptOutRegion || hasManuallyConsented);
}
export const oneTrustMocks = {
  generateEnvoyConsentHeader() {
    if (isTesting()) {
      return {};
    }
    const envoyConsentDefaultHeader = {
      [X_BLOCK_COOKIES]: X_BLOCK_COOKIES_DEFAULT_VALUE
    };

    // If the onetrust script ran, oneTrustActivityGroups will always be populated with C0001
    const activeGroups = getOneTrustActiveGroups();
    if (hasConsentBeenSet() && activeGroups) {
      // X-Block-Cookies is always included to inform server that we need to filter cookies based
      // on X-Allow-Cookies categories.
      return {
        ...envoyConsentDefaultHeader,
        [X_ALLOW_COOKIES]: activeGroups
      };
    }
    return envoyConsentDefaultHeader;
  },
  hasConsent(consentLevel) {
    if (!consentLevel) {
      throw new Error('Consent level must be provided for OneTrust. Consent levels are available in `@square/dashboard-utilities/utils/one-trust/one-trust-compliance`.');
    }
    return isTesting() || onetrustWindow.SqOneTrust?.groupConsentHash?.[consentLevel] === '1';
  },
  onFirstConsent(...args) {
    return _onFirstConsent(...args);
  },
  onFirstRejection(...args) {
    return _onFirstRejection(...args);
  }
};
export function hasConsent(consentLevel) {
  return oneTrustMocks.hasConsent(consentLevel);
}

/**
 * Return a promise which resolves when user grants the consent level passed in.
 * @param {*} consentLevel The consent level for OneTrust
 */
function _onFirstConsent(appInstanceOrOwner, consentLevel, callback) {
  if (hasConsent(consentLevel)) {
    callback();
    return;
  }
  function executeAfterOneTrust() {
    // Resolve if consent has been granted. Otherwise keep listeners waiting.
    if (hasConsent(consentLevel)) {
      callback();
      document.removeEventListener(POST_NEW_ONE_TRUST_INSTANCE, executeAfterOneTrust);
    }
  }
  document.addEventListener(POST_NEW_ONE_TRUST_INSTANCE, executeAfterOneTrust);

  // TODO(DBF-1141): this should not be optional, but the Persistable util requires it for now
  if (appInstanceOrOwner) {
    registerDestructor(appInstanceOrOwner, () => {
      document.removeEventListener(POST_NEW_ONE_TRUST_INSTANCE, executeAfterOneTrust);
    });
  }
}

/**
 * Return a promise which resolves when user rejects the consent level passed in.
 * @param {*} consentLevel The consent level for OneTrust
 */
function _onFirstRejection(appInstanceOrOwner, consentLevel, callback) {
  if (!hasConsent(consentLevel) && hasConsentBeenSet()) {
    callback();
    return;
  }
  function executeAfterOneTrust() {
    if (!hasConsent(consentLevel) && hasConsentBeenSet()) {
      callback();
      document.removeEventListener(POST_NEW_ONE_TRUST_INSTANCE, executeAfterOneTrust);
    }
  }
  document.addEventListener(POST_NEW_ONE_TRUST_INSTANCE, executeAfterOneTrust);
  registerDestructor(appInstanceOrOwner, () => {
    document.removeEventListener(POST_NEW_ONE_TRUST_INSTANCE, executeAfterOneTrust);
  });
}
export function getConsent(appInstanceOrOwner, consentLevel) {
  return new Promise(resolve => {
    onFirstConsent(appInstanceOrOwner, consentLevel, () => resolve(true));
    onFirstRejection(appInstanceOrOwner, consentLevel, () => resolve(false));
  });
}
export function generateEnvoyConsentHeader() {
  return oneTrustMocks.generateEnvoyConsentHeader();
}
export function showOneTrustModal() {
  onetrustWindow.OneTrust?.ToggleInfoDisplay();
}
export function isInEU() {
  return onetrustWindow.SqOneTrust?.userLocatedInEU;
}
export function onFirstConsent(...args) {
  return oneTrustMocks.onFirstConsent(...args);
}
export function onFirstRejection(...args) {
  return oneTrustMocks.onFirstRejection(...args);
}